import React, { useState } from "react";
import { Link } from "react-router-dom"; //  Importamos Link
import "./Navbar.css";
import "@fontsource/fira-sans";
import "@fontsource/fira-sans/300.css";

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <nav className="navbar">
            <div className="menu-toggle" id="menu-toggle" onClick={toggleMenu}>
                <p><i className="fa-solid fa-bars fa-lg"></i></p>
            </div>
            <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
                <li className="menu-toggle" id="menu-toggle" onClick={toggleMenu}>
                    <i className="fa-solid fa-bars fa-lg"></i>
                </li>
                <li><i className="fa-solid fa-house"></i><Link to="/">Inicio</Link></li>
                <li><i className="fa-solid fa-user"></i><Link to="/#conoce">Conócenos</Link></li>
                <li><i className="fa-solid fa-circle-info"></i><Link to="/#indicaciones">Indicaciones</Link></li>
                <li><i className="fa-solid fa-stethoscope"></i><Link to="/anestesia">Tipos de Anestesia</Link></li>
                <li><i className="fa-solid fa-question"></i><Link to="/preguntas">Preguntas Frecuentes</Link></li>

                
            </ul>
        </nav>
    );
}

export default Navbar;
